// extracted by mini-css-extract-plugin
module.exports = {"WorkList":"WorkList_WorkList__148Fd","More":"WorkList_More__1oAWz"};